//
//
//
//
//
//
//

import _ from 'underscore'
// import DIC from '@/index/dictionary'

export default {
  props: {
    tab: {
      default: ''
    },
    searchData: {
      default: {}
    }
  },
  data: function(){
    return {
      search: _.extend({}, this.searchData),
      table: [],
      page: {
        pageNo: 1,
        pageSize: 20,
        total: 0
      },
      loading: false
    }
  },
  watch: {
    tab: {
      handler (val) {
        if (val && val == 'dealer') {
          this.handleLoadTableData()
        }
      },
      immediate: true
    }
  },
  components: {
    PageHeader: () => import('./components/PageHeader/index.vue'),
    PageMain: () => import('./components/PageMain/index.vue')
  },
  mounted () {
  },
  methods: {
    handleLoadTableData () {
      this.loading = true
      let data = _.extend({}, this.search, _.pick(this.page, 'pageNo', 'pageSize'))
      // console.log('data', data)
      this.$axios.get('/mtea/store/admin/report/dealer/list', { params: data }).then(res => {
        // console.log('res', res)
        this.page.total = res.total
        this.table = res.records
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
